import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'levelsStateTranslate',
  standalone: true
})
export class LevelsStateTranslatePipe implements PipeTransform {
  transform(value: string): string {
    value = value.toLowerCase();
    switch (value) {
      case 'critical':
        return $localize`critical`;
      case 'warning':
        return $localize`warning`;
      case 'info':
        return $localize`info`;
      case 'acknowledged':
        return $localize`acknowledged`;
      case 'acknow':
        return $localize`acknow`;
      case 'clear':
        return $localize`clear`;
      case 'all clear':
        return $localize`all clear`;
      case 'new':
        return $localize`new`;
      case 'resolved':
        return $localize`resolved`;
      case 'offline':
        return $localize`offline`;
      case 'critical alert':
        return $localize`Critical Alert`;
      case 'warning alert':
        return $localize`Warning Alert`;
      case 'info alert':
        return $localize`Info Alert`;
      case 'hold':
        return $localize`Hold`;
      case 'ca-review':
        return $localize`CA Review`;
      case 'in-progress':
        return $localize`In Progress`;
      case 'integrated':
        return $localize`Integrated`;
      default:
        return value;
    }
  }
}
